import { Injectable } from '@angular/core'
import { ItemTypeEnum } from 'libs/gb-front/item/data-access/src'
import { AuctionFacade, AuctionStatusEnum } from 'libs/gb-front/auction/data-access/src'
import { map, Observable } from 'rxjs'
import { ItemEntity } from 'libs/gb-front/selected-item/data-access/src/lib/+state/selected-item.models'

@Injectable({
  providedIn: 'root',
})
export class GbAuctionTimerService {
  constructor(private auctionFacade: AuctionFacade) {}

  /**
   * Return whether a timer should be shown for the current auction
   * @param item
   */
  shouldShowTimer(item?: ItemEntity): Observable<boolean> {
    return this.auctionFacade.auction$.pipe(
      map((auction) => {
        if (item && item.item_type !== ItemTypeEnum.Bidding) {
          return false
        }
        return (
          (auction.scheduled && auction.status === AuctionStatusEnum.Running) ||
          (auction.scheduled_start_enabled &&
            (auction.status === AuctionStatusEnum.Stopped || auction.status === AuctionStatusEnum.Paused))
        )
      }),
    )
  }

  /**
   * Return whether the start timer should be shown
   * @param item
   */
  shouldShowStartTimer(item?: ItemEntity): Observable<boolean> {
    return this.auctionFacade.auction$.pipe(
      map((auction) => {
        if (!auction) {
          return false
        }
        if (item && item.item_type !== ItemTypeEnum.Bidding) {
          return false
        }
        if (auction.scheduled_start_enabled && auction.scheduled_start) {
          return (
            [AuctionStatusEnum.Stopped, AuctionStatusEnum.Paused].includes(auction.status as AuctionStatusEnum) &&
            new Date(auction.scheduled_start) > new Date()
          )
        }
        return false
      }),
    )
  }

  /**
   * Return whether the end timer should be shown
   * @param item
   */
  shouldShowEndTimer(item?: ItemEntity): Observable<boolean> {
    return this.auctionFacade.auction$.pipe(
      map((auction) => {
        if (!auction) {
          return false
        }
        if (item && item.item_type !== ItemTypeEnum.Bidding) {
          return false
        }
        return auction.scheduled && !!auction.scheduled_end && auction.status === AuctionStatusEnum.Running
      }),
    )
  }
}
